import Button from "presentation/components/Button/Button";
import { useNavigate } from "react-router-dom";
import styles from "../FooterLink.module.scss";

const CookiePolicyDK = () => {

    const navigate = useNavigate();

    return (
        <div className="d-flex justify-content-center align-items-center w-100">
            <div className={`${styles.popup} px-5 py-4 mb-2`}>

                <h1>Cookie-politik</h1>
                <p>
                    Vores webside anvender cookies til at skelne dig fra andre brugere af vores webside.
                    Det hjælper os med at give dig en god oplevelse, når du browser vores webside, og det gør det også muligt for os at forbedre vores webside.
                    Hvis du fortsætter med at browse websiden, accepterer du vores brug af cookies.
                </p>

                <h2>Hvordan denne webside benytter cookies</h2>
                <h3>Hvad er en cookie?</h3>
                <p>
                    En cookie er en lille fil bestående af bogstaver og tal, som vi gemmer på din browser eller harddisken i din computer. Cookies indeholder information,
                    som overføres til din computers harddisk, men disse cookies indeholder ikke identificerbar information.
                </p>


                <h2>Hvad vi bruger cookies til:</h2>

                <h3>1. Forbedre vores webside</h3>
                <p>
                    Udelukkende til statistiske formål sporer vi, hvor mange individuelle brugere vi har, og hvor ofte de besøger vores webside. Vi indsamler anonyme data, som fortæller os,
                    hvilke af vores sider, der hyppigst bliver besøgt, samt af hvilke typer brugere og fra hvilke lande. Det gør det muligt for os at se, hvilket indhold,
                    der er mere populært end andet. For at kunne gøre dette, anvender vi et analytisk web-værktøj kaldet Google Analytics.
                </p>

                <h3>2. Sikre at vores online reklamer er målrettede og relevante</h3>
                <p>
                    Vi vil evt. fra tid til anden benytte reklamer på andre websider for at promovere denne webside.
                    De reklamepartnere, vi benytter, kan tilføje reklamer, som de mener er af størst interesse for dig baseret på information om dit besøg på denne og andre websider
                    (denne information er anonym, idet den ikke omfatter dit navn, adresse, mailadresse eller telefonnummer).
                </p>
                <p>
                    For at kunne gøre det, kan det være nødvendigt for vores reklamepartner at sætte en cookie ind i din computer. Desuden kan de for at identificere,
                    at du er en del af den relevante målgruppe, identificere, at du tidligere har besøgt denne webside ved at bruge en cookie, der er droppet fra denne webside (det kaldes gen-målretning).
                </p>
                <p>
                    Disse reklame-cookies betegnes typisk som ’tredjepart-cookies’, fordi reklamerne og sporingen foretages af en ’tredjepart’.
                </p>
                <p>
                    For yderligere information om denne type online adfærdsbestemte reklamer, om cookies og om, hvordan man fravælger denne funktion gå til{" "}
                    <a
                        href="https://www.youronlinechoices.co.uk"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        www.youronlinechoices.co.uk
                    </a>.
                </p>
                <div className="policySection">
                    <h2>Hvilke cookies vi bruger:</h2>
                    <ul>
                        <li>
                            <p>
                                <strong>Analyse-/præstationscookies:</strong> De gør det muligt for os at genkende og tælle antallet af
                                besøgende og se, hvordan de besøgende bevæger sig rundt på vores webside, når de bruger den.
                                Det hjælper os med at forbedre den måde, vores webside fungerer på, for eksempel ved at sikre,
                                at brugerne nemt kan finde, hvad de leder efter.
                            </p>
                        </li>
                    </ul>
                    <p>
                        Du finder mere information om de individuelle cookies, vi benytter, og hvilke formål vi benytter dem til nedenfor:
                    </p>
                    <table className={`${styles.cookieTable}`}>
                        <thead>
                            <tr>
                                <th>Cookie-titel</th>
                                <th>Cookie-navn</th>
                                <th>Type</th>
                                <th>Tredjepart</th>
                                <th>Formål</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>_UTM</td>
                                <td>Analytics</td>
                                <td>Siteanalyse</td>
                                <td>Ikke relevant</td>
                                <td>Bruges til at spore besøg og logins på 1link platformen.</td>
                            </tr>
                            <tr>
                                <td>BIGipServer#</td>
                                <td>BIGipServer#</td>
                                <td>HTTP</td>
                                <td>Ikke relevant</td>
                                <td>
                                    Bruges til at distribuere trafik til websiden på flere servere for at optimere responstiderne.
                                </td>
                            </tr>
                            <tr>
                                <td>__utm.gif</td>
                                <td>utmgif</td>
                                <td>Siteanalyse</td>
                                <td>Ikke relevant</td>
                                <td>
                                    Google Analytics Sporingskode som logger detaljer om den besøgendes browser og computer.
                                </td>
                            </tr>
                            <tr>
                                <td>__utma</td>
                                <td>utma</td>
                                <td>Siteanalyse</td>
                                <td>Ikke relevant</td>
                                <td>Bruges til at skelne brugere og deres besøg. Bruges af Google Analytics</td>
                            </tr>
                            <tr>
                                <td>__utmb</td>
                                <td>utmb</td>
                                <td>Siteanalyse</td>
                                <td>Ikke relevant</td>
                                <td>
                                    Registrerer et tidsstempel med det præcise klokkeslet, hvor brugeren går ind på websiden.
                                    Bruges af Google Analytics til at udregne varigheden af et websidebesøg.
                                </td>
                            </tr>
                            <tr>
                                <td>__utmc</td>
                                <td>utmc</td>
                                <td>Siteanalyse</td>
                                <td>Ikke relevant</td>
                                <td>
                                    Registrerer et tidsstempel med det præcise klokkeslet, hvor brugeren forlader websiden.
                                    Bruges af Google Analytics til at udregne varigheden af et websidebesøg.
                                </td>
                            </tr>
                            <tr>
                                <td>__utmt</td>
                                <td>utmt</td>
                                <td>Siteanalyse</td>
                                <td>Ikke relevant</td>
                                <td>Bruges til at gøre hastigheden af henvendelser til serveren hurtigere.</td>
                            </tr>
                            <tr>
                                <td>__utmz</td>
                                <td>utmz</td>
                                <td>Siteanalyse</td>
                                <td>Ikke relevant</td>
                                <td>
                                    Gemmer trafikkilden eller kampagnen, der forklarer, hvordan brugeren kom frem til din webside.
                                    Bruges af Google Analytics.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="policySection">
                    <h2>Hvordan kan du styre dine cookies?</h2>

                    <h3>Browserindstillinger</h3>
                    <p>
                        De fleste browsere kan ændres, så de forebygger, at din computer accepterer cookies, selv om dette kan medføre,
                        at nogle af funktionerne på denne webside (og andre websider) ikke vil fungere ordentligt og evt. begrænse din brugeroplevelse.
                    </p>
                    <p>
                        Disse indstillinger findes typisk under din browsers ‘options’ eller ‘preferences’ menu. For at forstå disse indstillinger vil nedenstående links evt.
                        være nyttige. Alternativt kan du bruge ’Help’ optionen i din browser for yderligere detaljer.
                    </p>
                    <p>
                        <a
                            href="https://support.microsoft.com/en-gb/kb/196955"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Cookie indstillinger i Internet Explorer
                        </a>
                    </p>
                    <p>
                        <a
                            href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Cookie indstillinger i Firefox
                        </a>
                    </p>
                    <p>
                        <a
                            href="https://support.google.com/chrome/answer/95647?hl=en"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Cookie indstillinger i Chrome
                        </a>
                    </p>

                    <h3>Fravalg af anonyme Google Analytics cookies</h3>
                    <p>
                        Du kan installere en Google Analytics browser 'plug in', som forhindrer websiden i at sende information om dit besøg til Google Analytics. Der er mere information om dette nedenfor.
                    </p>
                    <p>
                        <a
                            href="https://www.google.com/intl/en/analytics/privacyoverview.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Google Analytics og Privatliv
                        </a>
                    </p>

                    <h3>Fravalg af tredjepart-cookies</h3>
                    <p>
                        For at forhindre tredjepart-cookies i at blive droppet ind i din browser kan du gå til den pågældende tredjeparts webside og generere en ‘no thanks’ engangscookie.
                        Det vil forhindre, at der sendes flere cookies til din browser fra den pågældende tredjepart. Tredjeparten, der bruges af denne webside, er DoubleClick,
                        og du finder anvisninger om, hvordan det gøres på linket nedenfor.
                    </p>
                    <p>
                        <a
                            href="https://www.google.com/privacy_ads.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            DoubleClick
                        </a>{" "}
                        (ejet af Google)
                    </p>

                    <p>
                        Hvis du gerne vil finde ud af mere om cookies og deres generelle brug, vil du evt. finde følgende links af interesse:
                    </p>
                    <p>
                        <a
                            href="https://www.microsoft.com/info/cookies.mspx"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Microsoft Cookies – Vejledning
                        </a>
                    </p>
                    <p>
                        <a
                            href="https://www.aboutcookies.org/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Alt om Cookies
                        </a>
                    </p>
                    <p>
                        IAB (The Internet Advertising Bureau) har følgende webside til rådighed, som giver specifik information om privatlivsproblemer i forbindelse med internetreklamer:
                    </p>
                    <p>
                        <a
                            href="https://www.youronlinechoices.com/uk/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            youronlinechoices.co.uk/uk
                        </a>
                    </p>
                    <p>
                        For yderligere juridisk information om privatlivsaspekter vil du evt. finde disse links nyttige:
                    </p>
                    <p>
                        <a
                            href="https://ico.org.uk/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            The Information Commissioner's Office
                        </a>
                    </p>
                    <p style={{ fontSize: '10px' }}>
                        Denne hjemmeside inderholder tekst, fotografier og grafik, som er under intellektuel beskyttelse. Alle rettigheder i dette materiale er enten ejet af epyx eller er licenseret til epyx af ejeren (ejerne) af disse rettigheder. 1link må kun tilgås af autoriserede brugere. Uautoriseret adgang er forbudt.
                    </p>
                    <div className={`${styles.close} float-end mt-3`}>
                        <Button label="OK" onClick={() => navigate("/")} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CookiePolicyDK